import { useTranslation } from 'react-i18next';

import { TeamSeats } from '../../../common/hooks/use-team-api.hook';
import { cn } from '../../../lib/utils';
import { seatsLeft } from './seats';

const Stat = ({ label, value, hint, tone, testId }: { label: string; value: string | number; hint?: string; tone?: 'danger'; testId: string }) => (
    <div className="flex min-w-0 flex-col gap-1 px-5 py-4" data-testid={testId}>
        <span className="text-xs text-muted-foreground">{label}</span>
        <span className={cn('font-heading text-2xl font-medium tracking-tight', tone === 'danger' && 'text-destructive')}>
            {value}
            {hint && <span className="ms-2 text-sm font-normal text-muted-foreground">{hint}</span>}
        </span>
    </div>
);

/** How many users the plan allows, how many the team has (and has invited), and how many are left. */
export function TeamSeatsPanel({ seats }: { seats: TeamSeats }) {
    const { t } = useTranslation();
    const unlimited = seats.limit < 0;
    const left = seatsLeft(seats);

    return (
        <div className="grid grid-cols-1 divide-y rounded-xl border bg-card sm:grid-cols-3 sm:divide-x sm:divide-y-0 rtl:sm:divide-x-reverse" data-testid="team-seats">
            <Stat testId="seats-allowed" label={t('VENDOR_TEAM.SEATS_ALLOWED')} value={unlimited ? t('VENDOR_TEAM.SEATS_UNLIMITED') : seats.limit} />
            <Stat
                testId="seats-used"
                label={t('VENDOR_TEAM.SEATS_IN_USE')}
                value={seats.used}
                hint={seats.reserved > 0 ? t('VENDOR_TEAM.SEATS_INVITED', { count: seats.reserved }) : undefined}
            />
            <Stat
                testId="seats-left"
                label={t('VENDOR_TEAM.SEATS_REMAINING')}
                value={unlimited ? t('VENDOR_TEAM.SEATS_UNLIMITED') : left}
                tone={left === 0 ? 'danger' : undefined}
            />
        </div>
    );
}
